import React from "react";
import { Typography } from "@mui/material";
export default () => (
  <Typography variant="h5">Reports Module - Coming Soon</Typography>
);
